var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M4,2H22V0H4A2,2,0,0,0,2,2V13H0v3H14V13H4ZM23,4H17a1,1,0,0,0-1,1V15a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V5A1,1,0,0,0,23,4Zm-1,9H18V6h4Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }